/** Date ranges as YYYY-MM-DD in local time (used by the party ledger and Banking). */

export function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

const isoOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/** This week: Monday → today. */
export function weekRange(now = new Date()) {
  const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - ((now.getDay() + 6) % 7));
  return { from: isoOf(monday), to: isoOf(now) };
}

/** Calendar month. offset 0 = 1st → today, -1 = whole of last month. */
export function monthRange(offset = 0, now = new Date()) {
  const first = new Date(now.getFullYear(), now.getMonth() + offset, 1);
  const last = offset === 0 ? now : new Date(first.getFullYear(), first.getMonth() + 1, 0);
  return { from: isoOf(first), to: isoOf(last) };
}

/** Indian financial year (1 Apr – 31 Mar). offset 0 = current FY, -1 = last FY. */
export function financialYearRange(offset = 0, now = new Date()) {
  const startYear = (now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1) + offset;
  const from = `${startYear}-04-01`;
  const fyEnd = `${startYear + 1}-03-31`;
  const to = offset === 0 ? todayIso() : fyEnd;
  return { from, to };
}
